import { render, staticRenderFns } from "./BottonmMenu2Edit.vue?vue&type=template&id=01b498ee"
import script from "./BottonmMenu2Edit.vue?vue&type=script&lang=js"
export * from "./BottonmMenu2Edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports